import React from "react";
import { useLang } from "@/lib/i18n";
import { Globe } from "lucide-react";
import { Button } from "@/components/ui/button";

export function LangToggle({ variant = "light" }) {
  const { lang, setLang } = useLang();
  const isDark = variant === "dark";
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => setLang(lang === "en" ? "th" : "en")}
      data-testid="language-toggle-button"
      className={
        isDark
          ? "border border-amber-300/30 text-amber-100 hover:bg-amber-200/10 hover:text-amber-100 rounded-full font-mono text-[11px] tracking-widest uppercase"
          : "border border-stone-300 text-stone-700 hover:bg-stone-100 rounded-full font-mono text-[11px] tracking-widest uppercase"
      }
    >
      <Globe className="w-3.5 h-3.5 mr-1.5" />
      {lang === "en" ? "TH" : "EN"}
    </Button>
  );
}
